const documentsTypes = {
    SET_USER_DOCUMENTS: "SET_USER_DOCUMENTS",
};

export default documentsTypes;
